<template>
<div class="finaTabs" ref="finaTabs">
  <el-tabs
    v-model="editableTabsValue" type="card" closable @tab-remove="removeTab" @tab-click="clickTab">
    <el-tab-pane
      v-for="(item) in editableTabs"
      :key="item.name"
      :label="item.meta.title"
      :name="item.name">
    </el-tab-pane>
  </el-tabs>
</div>
</template>

<script>
export default {
  props: {
    menuData: {
      type: Array,
      deafault: () => []
    }
  },
  data () {
    return {
      editableTabs: [],
      editableTabsValue: '',
      editMap: {},
      idToIndex: {}
    }
  },
  methods: {
    addTab (data) {
      if (!this.editMap[data.name]) {
        const length = this.editableTabs.push(data)
        this.$emit('addCache', data)
        this.editMap[data.name] = true
        this.idToIndex[data.name] = length - 1
      }
      this.editableTabsValue = data.name
    },
    removeTab (targetName) {
      if (this.editableTabs.length > 1) {
        delete this.editMap[targetName]
        let index = this.idToIndex[targetName]
        this.editableTabs.splice(index, 1)
        this.$emit('removeCache', index)
        index = index - 1 < 0 ? 0 : index - 1
        this.changeMenuIndexMap()
        if ( this.idToIndex[this.editableTabsValue] === undefined ) {
          this.$emit('toTabLink', this.editableTabs[index])
        }
      }
    },
    changeMenuIndexMap () {
      const data = {}
      this.editableTabs.forEach((elem, index) => {
        data[elem.name] = index
      })
      this.idToIndex = data
    },
    clickTab (e) {
      let index = this.idToIndex[e.name]
      this.$emit('toTabLink', this.editableTabs[index])
    }
  }
}
</script>

<style lang="less" scoped>
.finaTabs {
  padding: 10px 10px 0 10px;
  background-color: #fff;
}
/deep/ .is-top .is-active {
  background-color: #5082f7;
  color: #fff;
}
</style>
